import { Component, Prop, PropSync, VModel, Vue } from 'vue-property-decorator';
import { Category } from '@/models/Category';
import { FastProductVariant } from '@/models/FastProductVariant';

@Component<ProductVariantAutocomplete>({})
export default class ProductVariantAutocomplete extends Vue {
  //#region @VModel

  @VModel()
  protected internalValue!: string | FastProductVariant;

  //#endregion

  //#region @PropSyncs

  @PropSync('searchInput')
  protected internalSearchInput!: string;

  //#endregion

  //#region @Props

  @Prop({ default: 'keyboard_arrow_down' })
  protected appendIcon!: string;

  @Prop({ default: '#49B39D' })
  protected color!: string;

  @Prop({ default: false })
  protected disabled!: boolean;

  @Prop({ default: () => [] })
  protected items!: FastProductVariant[];

  @Prop({ default: 'Choose a product variant' })
  protected label!: string;

  @Prop({ default: 'Product variant' })
  protected placeholder!: string;

  @Prop({ default: true })
  protected returnObject!: boolean;

  @Prop({ default: 'Product variant search' })
  protected searchPlaceholder!: string;

  @Prop({ default: 'Product variant' })
  protected selectionSummaryLabel!: string;

  @Prop({ default: true })
  protected showPills!: boolean;

  //#endregion

  //#region Handlers

  protected onFocus(): void {
    this.$emit('focus');
  }

  //#endregion

  //#region Helpers

  protected itemText(item: FastProductVariant): string {
    return [
      item.product_name ? item.product_name : '',
      item.color && typeof item.color !== 'string' ? item.color.name : '',
      item.size && typeof item.size !== 'string' ? item.size.name : '',
      item.upc ? item.upc : '',
    ]
      .filter((item) => !!item)
      .join(' - ');
  }

  //#endregion
}
